import { render, staticRenderFns } from "./SubmittedResumes.vue?vue&type=template&id=57652f20&scoped=true&"
import script from "./SubmittedResumes.vue?vue&type=script&lang=js&"
export * from "./SubmittedResumes.vue?vue&type=script&lang=js&"
import style0 from "./SubmittedResumes.vue?vue&type=style&index=0&id=57652f20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57652f20",
  null
  
)

export default component.exports